"use client";

import Skeleton from "@mui/material/Skeleton";

export const LoadingView = () => (
  <div className="max-w-xs space-y-3">
    <Skeleton variant="rounded" className="h-40" />
    <Skeleton variant="rounded" className="h-10" />
  </div>
);
